import React from "react";
import { useSelector } from "react-redux";
import { Modal, ModalBody, Table } from "reactstrap";

const ChatDetailModal = (props) => {
  let { checkQuestionPriority } = useSelector((state) => state.chat);
  return (
    <Modal
      isOpen={props.showInstruction}
      toggle={props.handleShowInstruction}
      size="xl"
      centered
    >
      <ModalBody>
        <div className="d-flex justify-content-end">
          <div>
            <i
              onClick={props.handleShowInstruction}
              className="fas fa-times"
            ></i>
          </div>
        </div>
        <div>
          <p className="text-dark modal-title">Chat Slot Booking details:</p>
          <Table className="table align-items-center mt-3" responsive>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading">
                  Email
                </th>
                <th scope="col" className="custom-table-heading">
                  Chat Rate x Minutes= $
                </th>
                {checkQuestionPriority.questionId ? (
                  <th>Subject of Fans Question(ID#________)</th>
                ) : null}
                <th scope="col" className="custom-table-heading text-center">
                  High priority question
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="table-chat-request custom-table-text">
                  {props.data?.fan_email}
                </td>
                <td className="table-chat-request custom-table-text">
                  {props.data?.athlete_chat_rate * props.data?.chat_minutes}
                </td>
                {checkQuestionPriority.questionId ? (
                  <td className="table-chat-request custom-table-text">
                    {checkQuestionPriority.questionId}
                  </td>
                ) : null}
                <td className="text-center custom-table-text">
                  {checkQuestionPriority.isHighPriority}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ChatDetailModal;
